<template>
  <v-layout>
    <v-flex>
      <v-toolbar flat>
        <h3 class="font-weight-light black--text">Orçamento</h3>
        <v-spacer></v-spacer>

        <v-btn
          outlined
          color="default"
          class="mr-2"
          @click="$router.push({ name: 'orcamentos' })"
          >Voltar</v-btn
        >
        <v-btn outlined color="default" class="mr-2" @click="cadastrarOrcamento"
          >Novo</v-btn
        >
        <v-btn
          outlined
          color="default"
          class="mr-2"
          @click="modalSalvar = true"
          v-if="
            $helper.verificaPermissao('cadastrar-orcamento') ||
            $helper.verificaPermissao('atualizar-orcamento')
          "
        >
          Salvar</v-btn
        >
        <v-btn
          outlined
          color="default"
          class="mr-2"
          @click="modalConverterVendaOrcamento = true"
          v-if="
            getOrcamento.id &&
            $helper.verificaPermissao('converter-orcamento-venda')
          "
          >Converter em Venda</v-btn
        >
        <v-btn
          outlined
          color="default"
          class="mr-2"
          @click="setModalImprimirOrcamento(true)"
          v-if="getOrcamento.id"
        >
          Imprimir</v-btn
        >
        <v-btn
          outlined
          color="default"
          class="mr-2"
          @click="cadastrarCrmProposta()"
          v-if="
            getOrcamento.id &&
            $helper.verificaPermissao('cadastrar-propostas-crm')
          "
        >
          Agendar Contato</v-btn
        >
        <v-menu bottom left transition="slide-y-transition" class="ml-10 mr-10">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="cadastrarProduto"
              v-if="$helper.verificaPermissao('cadastrar-produto')"
            >
              <v-list-item-action>
                <v-icon>window</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cadastrar Produto</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="cadastrarContato"
              v-if="$helper.verificaPermissao('cadastrar-contato')"
            >
              <v-list-item-action>
                <v-icon>perm_identity</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Cadastrar Contato</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="getOrcamento.id"
              @click="setModalEnviarEmailOrcamento(true)"
            >
              <v-list-item-action>
                <v-icon>email</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Enviar por e-mail</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              @click="setModalExcluirOrcamento(true)"
              v-if="
                $helper.verificaPermissao('excluir-orcamento') &&
                getOrcamento.id
              "
            >
              <v-list-item-action>
                <v-icon>highlight_off</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Excluir Orçamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- <v-btn color="primary" class="ma-2" v-if="$route.params.id">Enviar por e-mail</v-btn> -->
      </v-toolbar>
      <v-container :fluid="true">
        <v-card outlined>
          <v-card-title>
            <h6>Pesquisar Produtos (F2)</h6>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text class="px-7">
            <v-layout row wrap>
              <v-flex xs12 md2>
                <v-text-field
                  dense
                  outlined
                  v-model="codigo_barras"
                  id="codigo_barra"
                  label="Código de Barras"
                  type="number"
                  class="ml-1 mr-1"
                  @keyup.enter="pesquisarPorCodigoDeBarras"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <!-- <v-autocomplete
                  label="Produto"
                  :items="getProdutos"
                  item-text="descricao"
                  item-value="id"
                  :search-input.sync="descricao"
                  outlined
                  v-model="getProduto.id"
                  @change="buscarProduto(getProduto.id)"
                  class="ml-3 mr-3"
                  > -->
                <v-text-field
                  dense
                  v-model="getProduto.descricao"
                  label="Produto"
                  outlined
                  class="ml-1 mr-1"
                >
                </v-text-field>
                <template v-slot:selection="data"
                  >{{ data.item.descricao }} - {{ data.item.marca }}</template
                >
                <template v-slot:item="data"
                  >{{ data.item.id }} - {{ data.item.descricao }} -
                  {{ data.item.marca }}</template
                >
                <!-- </v-autocomplete> -->
              </v-flex>
              <v-flex xs12 md1>
                <v-text-field
                  dense
                  outlined
                  v-model="getProduto.preco_venda"
                  @blur="somaTotalItem"
                  label="P. Unit."
                  class="ml-1 mr-1"
                  @keyup.enter="focusQuantidade"
                  id="preco_unitario"
                  v-mask="[
                    '#,##',
                    '##,##',
                    '###,###',
                    '#.###,##',
                    '##.###,##',
                    '###.###,##',
                  ]"
                  @click="$event.target.select()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md1>
                <v-text-field
                  dense
                  outlined
                  v-model="quantidade"
                  @blur="somaTotalItem"
                  label="Quantidade"
                  id="quantidade"
                  @keyup.enter="focusDescontoUnitario"
                  class="ml-1 mr-1"
                  v-mask="[
                    '#,##',
                    '##,##',
                    '###,###',
                    '#.###,##',
                    '##.###,##',
                    '###.###,##',
                  ]"
                  @click="$event.target.select()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md1>
                <v-text-field
                  dense
                  outlined
                  v-model="subtotal"
                  @blur="aplicaDescontoItem"
                  label="Subtotal"
                  class="ml-1 mr-1"
                  readonly
                  v-mask="[
                    '#,##',
                    '##,##',
                    '###,###',
                    '#.###,##',
                    '##.###,##',
                    '###.###,##',
                  ]"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md1>
                <v-text-field
                  dense
                  outlined
                  v-model="desconto"
                  @blur="aplicaDescontoItem"
                  label="Desconto %"
                  id="desconto_unitario"
                  @keyup.enter="addItemOrcamento"
                  class="ml-1 mr-1"
                  v-mask="[
                    '#,##',
                    '##,##',
                    '###,###',
                    '#.###,##',
                    '##.###,##',
                    '###.###,##',
                  ]"
                  @click="$event.target.select()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md2>
                <v-text-field
                  dense
                  outlined
                  v-model="total"
                  label="Total"
                  class="ml-1 mr-1"
                  readonly
                  v-mask="[
                    '#,##',
                    '##,##',
                    '###,###',
                    '#.###,##',
                    '##.###,##',
                    '###.###,##',
                  ]"
                  append-outer-icon="control_point"
                  @click:append-outer="addItemOrcamento"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <!-- <v-card-actions>
            <v-btn color="primary" @click="addItemOrcamento" outlined block>INSERIR PRODUTO</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-container>

      <v-container grid-list-xs :fluid="true">
        <v-card outlined>
          <v-card-title>
            <h6>Orçamento</h6>
          </v-card-title>
          <v-card-text>
            <hr />
            <v-simple-table dense fixed-header height="400px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Código</th>
                    <th class="text-left">Descrição</th>
                    <!-- <th class="text-left">Estoque</th> -->
                    <th class="text-left">P. Unit.</th>
                    <th class="text-left">Quantidade</th>
                    <th class="text-left">Subtotal</th>
                    <th class="text-left">Desconto</th>
                    <th class="text-left">Total</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in getItensOrcamento" :key="p.id">
                    <td>{{ p.produto_id }}</td>
                    <td>{{ p.descricao }}</td>
                    <!-- <td>{{ p.estoque }}</td> -->
                    <td>{{ $helper.formatReal(parseFloat(p.preco)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.quantidade)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.subtotal)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.desconto)) }}</td>
                    <td>{{ $helper.formatReal(parseFloat(p.total)) }}</td>
                    <td>
                      <v-btn
                        x-small
                        color="error"
                        @click="removerItemOrcamento(p)"
                        outlined
                      >
                        <v-icon>delete_forever</v-icon>
                      </v-btn>
                      <v-btn
                        x-small
                        color="primary"
                        class="ml-2"
                        @click="visualizarProduto(p.produto_id)"
                        v-if="$helper.verificaPermissao('visualizar-produto')"
                        outlined
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <hr />
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="text-md-right text-xs-right">
                      <strong>Subtotal</strong>
                    </td>
                    <td width="10%">
                      <strong>{{ getOrcamento.subtotal }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-md-right text-xs-right">
                      <strong>Desconto</strong>
                    </td>
                    <td width="10%">
                      <strong>{{ getOrcamento.desconto }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td class="text-md-right text-xs-right">
                      <strong>Total</strong>
                    </td>
                    <td width="10%">
                      <strong>{{ getOrcamento.total }}</strong>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <hr />
            <br />
            <!-- <h4>Formas de Pagamentos</h4>
            <v-form ref="formFormaPagamento" class="mt-5 mb-5">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <v-text-field
                    label="Forma de Pagamento"
                    v-model="formaPagamento.descricao"
                    dense
                    outlined
                    class="ml-1 mr-1"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    label="Valor"
                    v-model="formaPagamento.valor"
                    dense
                    outlined
                    class="ml-1 mr-1"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    @click="$event.target.select()"
                    @keyup.13="addFormaPagamento"
                    append-outer-icon="control_point"
                    @click:append-outer="addFormaPagamento"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-simple-table
                    dense
                    fixed-header
                    height="auto"
                    v-if="getOrcamento.formas_pagamentos.length > 0"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Forma</th>
                          <th>Valor</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="f in getOrcamento.formas_pagamentos"
                          :key="f.id"
                        >
                          <td>{{ f.descricao }}</td>
                          <td>{{ f.valor }}</td>
                          <td>
                            <v-btn
                              x-small
                              color="error"
                              @click="removerFormaPagamento(f)"
                              outlined
                            >
                              <v-icon>delete_forever</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-flex>
              </v-layout>
            </v-form> -->
            <h4>Pesquisar Cliente (F3)</h4>
            <v-layout row wrap class="mt-5">
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-text-field
                    outlined
                    @input="debouncedBuscarContato"
                    dense
                    v-model="getContato.id"
                    label="Código do Cliente"
                    type="number"
                    class="ml-1 mr-1"
                    @keyup.enter="debouncedBuscarContato"
                    id="codigo_cliente"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    outlined
                    v-model="getContato.nome"
                    dense
                    label="Nome"
                    class="ml-1 mr-1"
                    append-icon="control_point"
                    @click:append="cadastrarContato()"
                    append-outer-icon="edit"
                    @click:append-outer="
                      getContato.id ? visualizarContato(getContato.id) : null
                    "
                  >
                  </v-text-field>
                </v-flex>
                <v-flex md12 md3>
                  <v-text-field
                    outlined
                    v-model="getContato.cpf_cnpj"
                    dense
                    label="CPF/CNPJ"
                    disabled
                    class="ml-1 mr-1"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex md12 md3>
                  <v-text-field
                    outlined
                    v-model="getContato.cep"
                    dense
                    label="CEP"
                    class="ml-1 mr-1"
                    disabled
                  >
                  </v-text-field>
                </v-flex>
                <v-flex md12 md5>
                  <v-text-field
                    outlined
                    v-model="getContato.logradouro"
                    dense
                    label="Logradouro"
                    class="ml-1 mr-1"
                    disabled
                  ></v-text-field>
                </v-flex>
                <v-flex md12 md1>
                  <v-text-field
                    outlined
                    v-model="getContato.numero"
                    dense
                    label="Número"
                    class="ml-1 mr-1"
                    disabled
                  >
                  </v-text-field>
                </v-flex>
                <v-flex md12 md3>
                  <v-text-field
                    outlined
                    v-model="getContato.complemento"
                    dense
                    label="Complemento"
                    class="ml-1 mr-1"
                    disabled
                  >
                  </v-text-field>
                </v-flex>
                <v-flex md12 md4>
                  <v-text-field
                    outlined
                    v-model="getContato.bairro"
                    dense
                    label="Bairro"
                    class="ml-1 mr-1"
                    disabled
                  >
                  </v-text-field>
                </v-flex>
                <v-flex md12 md4>
                  <v-text-field
                    outlined
                    v-model="getContato.cidade"
                    dense
                    label="Cidade"
                    class="ml-1 mr-1"
                    disabled
                  >
                  </v-text-field>
                </v-flex>
                <v-flex md12 md4>
                  <v-text-field
                    outlined
                    v-model="getContato.uf"
                    dense
                    label="UF"
                    class="ml-1 mr-1"
                    disabled
                  >
                  </v-text-field>
                </v-flex>
                <v-flex md12 md6>
                  <v-text-field
                    outlined
                    dense
                    label="Contatos"
                    disabled
                    class="ml-1 mr-1"
                    :value="`${
                      getContato.telefone ? getContato.telefone : ''
                    } ${getContato.celuar1 ? '/ ' + getContato.celular1 : ''} ${
                      getContato.celular2 ? '/ ' + getContato.celular2 : ''
                    } ${getContato.whatsapp ? '/ ' + getContato.whatsapp : ''}`"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex md12 md6>
                  <v-text-field
                    outlined
                    dense
                    label="WhatsApp"
                    disabled
                    class="ml-1 mr-1"
                    :value="`${getContato.whatsapp ? getContato.whatsapp : ''}`"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <!-- <v-flex xs12 md3>
                <v-layout row wrap>
                  <v-flex xs12 md12>
                    <v-text-field outlined v-model="getOrcamento.subtotal" dense label="SUBTOTAL" disabled>
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-text-field outlined v-model="descontoPercentual" dense label="DESCONTO %"
                      v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']"
                      id="desconto_percentual" @keyup.enter="modalSalvar = true" class="mr-1"></v-text-field>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-text-field outlined v-model="descontoReal" dense label="DESCONTO R$"
                      v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']"
                      id="desconto_percentual" @keyup.enter="modalSalvar = true" class="ml-1"></v-text-field>
                  </v-flex>

                  <v-flex xs12 md12>
                    <v-text-field outlined v-model="getOrcamento.total" dense label="TOTAL" disabled></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex> -->
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn
              outlined
              color="success"
              @click="modalSalvar = true"
              block
              v-if="
                $helper.verificaPermissao('cadastrar-orcamento') ||
                $helper.verificaPermissao('atualizar-orcamento')
              "
            >
              SALVAR ORÇAMENTO</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-container>
    </v-flex>

    <v-dialog v-model="modalSalvar" max-width="720">
      <v-card>
        <v-card-title>Salvar</v-card-title>
        <v-card-text>
          <h3 align="center">Tem certeza que deseja salvar este orçamento?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined color="default" @click="modalSalvar = false"
            >Não</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn outlined color="success" @click="salvar">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalConverterVendaOrcamento" max-width="720">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-alert dense border="left" type="warning" outlined>
            Será convertido somente os produtos que estiverem com o estoque
            suficiente.
          </v-alert>

          <h3 align="center">
            Tem certeza que deseja converter este orçamento em venda?
          </h3>
          <br />
        </v-card-text>
        <v-card-actions>
          <v-btn
            outlined
            color="default"
            @click="modalConverterVendaOrcamento = false"
            >Não</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn outlined color="success" @click="converterVenda(getOrcamento)"
            >Sim</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ModalCadastroProduto v-if="getModalCadastroProduto" />
    <ModalCadastroContato v-if="getModalCadastroContato" />
    <ModalPesquisarProduto
      @focusInputQuantidade="focusQuantidade"
      v-if="getModalPesquisarProdutosOrcamento"
    />
    <ModalPesquisarContato />
    <ModalExcluirOrcamento />
    <ModalImprimirOrcamento />
    <ModalEnviarOrcamentoEmail />
    <!-- <ModalInfoProposta /> -->
    <ModalCadastroCrmProposta />
    <ModalListarGradeProduto :botaoAdicionarProduto="true"/>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProdutoService from "@/services/ProdutoService";
import ModalExcluirOrcamento from "@/pages/orcamento/ModalExcluir";
import ModalCadastroContato from "@/pages/contato/ModalCadastro";
import ModalPesquisarContato from "@/pages/contato/ModalPesquisar";
import ModalCadastroProduto from "@/pages/produto/ModalCadastro";
import ModalPesquisarProduto from "@/pages/produto/ModalPesquisarProduto";
import ModalImprimirOrcamento from "@/pages/orcamento/ModalImprimir";
import ModalEnviarOrcamentoEmail from "@/pages/orcamento/ModalEnviarEmail";
//import ModalInfoProposta from "@/pages/orcamento/ModalInfoProposta";
import ModalCadastroCrmProposta from "@/pages/crm/proposta/ModalCadastro";
import ModalListarGradeProduto from "@/pages/produto/grade/ModalListar"

var _ = require("lodash");

export default {
  components: {
    ModalCadastroContato,
    ModalCadastroProduto,
    ModalPesquisarProduto,
    ModalPesquisarContato,
    ModalExcluirOrcamento,
    ModalImprimirOrcamento,
    ModalEnviarOrcamentoEmail,
    //ModalInfoProposta,
    ModalCadastroCrmProposta,
    ModalListarGradeProduto,
  },
  data() {
    return {
      cliente_id: 1,
      produto_id: "",
      descricao: "",
      preco: "",
      subtotal: "",
      desconto: 0,
      total: "",
      codigo_barras: "",
      quantidade: 1,
      descontoPercentual: 0,
      descontoReal: 0,
      tabs: 0,
      modalSalvar: false,
      descontoItem: 0,
      rules: {
        nome: [(v) => !!v || "Campo obrigatório."],
      },
      // modalImprimirOrcamento: false,
      modalConverterVendaOrcamento: false,
      formaPagamento: {
        id: "",
        descricao: "",
        valor: "",
      },
      rules: {
        forma_pagamento_descricao: [(v) => !!v || "Campo obrigatório."],
        forma_pagamento_valor: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  computed: {
    ...mapGetters([
      "getOrcamento",
      "getItensOrcamento",
      "getProduto",
      "getProdutos",
      "getContato",
      "getContatos",
      "getModalPesquisarProdutosOrcamento",
      "getModalCadastroProduto",
      "getModalCadastroContato",
    ]),
  },
  watch: {
    descricao: function () {
      this.debouncedPesquisarPorDescricao();
    },
    codigo_barras: function () {
      if (this.codigo_barras != "") {
        this.debouncedPesquisarPorCodigoDeBarras();
      }
    },
    quantidade: function () {
      if (this.quantidade != "" && this.quantidade != 0) {
        this.somaTotalItem();
      }
    },
    descontoPercentual: function () {
      this.aplicaDescontoPercentual();
    },
    descontoReal: function () {
      this.aplicaDescontoReal();
    },
    desconto: function () {
      this.aplicaDescontoItem();
    },
    getModalPesquisarProdutosOrcamento() {
      if (
        this.getModalPesquisarProdutosOrcamento == false &&
        this.getProduto.id
      ) {
        this.quantidade = "1,00";
        setTimeout(() => {
          this.focusQuantidade();
        }, 150);
      }
    },
  },
  methods: {
    ...mapActions([
      "cadastrarContato",
      "cadastrarProduto",
      "salvarOrcamento",
      "atualizarOrcamento",
      "setModalCadastroOrcamento",
      "setModalExcluirOrcamento",
      "buscarCliente",
      "pesquisarProdutoPorCodigoDeBarras",
      "listarProdutos",
      "listarContatos",
      "cadastrarOrcamento",
      "visualizarOrcamento",
      "visualizarProduto",
      "buscarProduto",
      "pesquisarProduto",
      "setModalPesquisarProdutosOrcamento",
      "setModalPesquisarContato",
      "converterOrcamentoParaVenda",
      "imprimirOrcamento4a",
      "imprimirOrcamentoCupom",
      "setDrawer",
      "imprimirPropostaA4",
      "setModalImprimirOrcamento",
      "buscarContato",
      "visualizarContato",
      "setModalEnviarEmailOrcamento",
      "cadastrarCrmProposta",
    ]),
    salvar() {
      if (!this.getContato.id) {
        this.getContato.id = null;
        // this.$store.commit('snackbarError', 'Selecione um cliente')
        // return
      }

      this.modalSalvar = false;
      // this.getOrcamento.desconto = this.getOrcamento.subtotal - this.getOrcamento.total
      this.getOrcamento.itens = this.getItensOrcamento;
      this.getOrcamento.cliente_id = this.getContato.id;
      // this.getOrcamento.formas_pagamentos = this.formasPagamento
      // this.getOrcamento.logradouro = this.getContato.logradouro
      // this.getOrcamento.numero = this.getContato.numero
      // this.getOrcamento.bairro = this.getContato.bairro
      // this.getOrcamento.cidade = this.getContato.cidade
      // this.getOrcamento.codigo_cidade = this.getContato.codigo_cidade
      // this.getOrcamento.uf = this.getContato.uf
      // this.getOrcamento.referencia_endereco = this.getContato.referencia_endereco
      // this.getOrcamento.telefone = this.getContato.telefone
      // this.getOrcamento.celular1 = this.getContato.celular1
      // this.getOrcamento.celular2 = this.getContato.celular2
      // this.getOrcmaneto.whatsapp = this.getContato.whatsapp
      if (this.getOrcamento.id) {
        this.atualizarOrcamento(this.getOrcamento);
      } else {
        this.salvarOrcamento(this.getOrcamento);
      }
    },
    converterVenda() {
      this.getOrcamento.itens = this.getItensOrcamento;
      this.converterOrcamentoParaVenda(this.getOrcamento);
    },

    somaTotalItem() {
      this.subtotal = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.quantidade) *
          this.$helper.cleanFormatReal(this.getProduto.preco_venda)
      );
      this.total = this.subtotal;
    },
    addItemOrcamento() {
      if (!this.getProduto.descricao) {
        this.$store.commit("snackbarWarning", "Selecione um produto.");
        return;
      }

      if (
        this.$helper.cleanFormatReal(this.desconto.toString()) >
        this.getProduto.desconto_maximo
      ) {
        this.$store.commit(
          "snackbarWarning",
          `O desconto máximo permitido é de ${this.getProduto.desconto_maximo} %`
        );
        return;
      }

      let item = {
        produto_id: this.getProduto.id,
        descricao: this.getProduto.descricao,
        preco: parseFloat(
          this.getProduto.preco_venda
            .toString()
            .replace(".", "")
            .replace(",", ".")
        ),
        quantidade: parseFloat(
          this.quantidade.toString().replace(".", "").replace(",", ".")
        ),
        subtotal: this.$helper.cleanFormatReal(this.subtotal.toString()),
        desconto:
          this.$helper.cleanFormatReal(this.subtotal.toString()) -
          this.$helper.cleanFormatReal(this.total.toString()),
        total: parseFloat(
          this.total.toString().replace(".", "").replace(",", ".")
        ),
        estoque: this.$helper.getEstoquePrincipalProduto(this.getProduto),
        grade_id: this.getProduto.grade_id,
      };

      this.$store.commit("addItemOrcamento", item);
      this.getOrcamento.subtotal = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getOrcamento.subtotal.toString()) +
          item.subtotal
      );
      this.getOrcamento.desconto = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getOrcamento.desconto.toString()) +
            item.desconto
        )
      );
      this.getOrcamento.total = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getOrcamento.subtotal.toString()) -
          this.$helper.cleanFormatReal(this.getOrcamento.desconto.toString())
      );

      this.codigo_barras = "";
      this.quantidade = "1,00";
      this.produto_id = "";
      this.subtotal = "0,00";
      this.total = "0,00";
      this.desconto = "0,00";
      document.getElementById("codigo_barra").focus();
      this.$store.commit("setProduto", {});
      this.getProduto.preco_venda = this.$helper.formatReal(parseFloat(0));
    },
    addFormaPagamento() {
      if (!this.formaPagamento.descricao) {
        this.$store.commit("snackbarWarning", "Descreva a forma de pagamento.");
        return;
      }

      if (!this.formaPagamento.valor) {
        this.$store.commit("snackbarWarning", "Informe um valor.");
        return;
      }

      this.formaPagamento.id =
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
      this.getOrcamento.formas_pagamentos.push({ ...this.formaPagamento });
      this.formaPagamento.id = "";
      this.formaPagamento.valor = "";
      this.formaPagamento.descricao = "";
    },
    removerFormaPagamento(item) {
      let index = this.getOrcamento.formas_pagamentos.indexOf(item);
      this.getOrcamento.formas_pagamentos.splice(index, 1);
    },
    _buscarContato() {
      this.buscarContato(this.getContato.id);
    },
    removerItemOrcamento(item) {
      this.getOrcamento.subtotal = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getOrcamento.subtotal) - item.subtotal
      );
      this.getOrcamento.desconto = this.$helper.formatReal(
        this.$helper.cleanFormatReal(this.getOrcamento.desconto) - item.desconto
      );
      this.getOrcamento.total = this.$helper.formatReal(
        parseFloat(
          this.$helper.cleanFormatReal(this.getOrcamento.total) - item.total
        )
      );

      // this.getOrcamento.subtotal = this.$helper.formatReal(this.$helper.cleanFormatReal(this.getOrcamento.subtotal) - item.subtotal);
      // this.getOrcamento.desconto = this.$helper.formatReal(this.$helper.cleanFormatReal(this.getOrcamento.desconto) - this.$helper.cleanFormatReal(this.$helper.formatReal(item.desconto)));
      // this.getOrcamento.total = this.$helper.formatReal(parseFloat(this.$helper.cleanFormatReal(this.getOrcamento.total) - item.total))
      this.aplicaDescontoPercentual();
      this.aplicaDescontoReal();
      this.$store.commit("removeItemOrcamento", item);
    },
    aplicaDescontoPercentual() {
      this.descontoReal = 0;
      let subtotal = parseFloat(
        this.getOrcamento.subtotal.toString().replace(".", "").replace(",", ".")
      );
      let desconto = parseFloat(
        this.descontoPercentual.toString().replace(".", "").replace(",", ".")
      );
      this.getOrcamento.total = this.$helper.formatReal(
        parseFloat(subtotal - (desconto / 100) * subtotal)
      );
    },
    aplicaDescontoReal() {
      this.descontoPercentual = 0;
      let subtotal = parseFloat(
        this.getOrcamento.subtotal.toString().replace(".", "").replace(",", ".")
      );
      let desconto = parseFloat(
        this.descontoReal.toString().replace(".", "").replace(",", ".")
      );
      this.getOrcamento.total = this.$helper.formatReal(
        parseFloat(subtotal - desconto)
      );
    },
    aplicaDescontoItem() {
      if (this.desconto) {
        let subtotal = this.$helper.cleanFormatReal(this.subtotal.toString());
        let desconto =
          (this.$helper.cleanFormatReal(this.desconto.toString()) / 100) *
          subtotal;
        this.total = this.$helper.formatReal(parseFloat(subtotal - desconto));
      } else {
        this.total = this.subtotal;
      }
    },
    pesquisarPorCodigoDeBarras() {
      if (this.codigo_barras == "") {
        document.getElementById("codigo_cliente").focus();
        return;
      }

      ProdutoService.porCodigoDeBarras(this.codigo_barras)
        .then((res) => {
          if (res.data.id) {
            let produto = res.data;
            produto.preco_venda = this.$helper.formatReal(
              parseFloat(res.data.preco_venda)
            );
            this.$store.commit("setProduto", produto);
            this.$store.commit("setItemOrcamento", produto);
            this.somaTotalItem();
            document.getElementById("preco_unitario").focus();
          } else {
            this.$store.commit("snackbarError", "Produto não encontado.");
            this.codigo_barras = "";
            document.getElementById("codigo_barra").focus();
          }
        })
        .catch((e) => {
          this.codigo_barras = "";
          document.getElementById("codigo_barra").focus();
          this.$store.commit("snackbarError", "Erro ao pesuisar produto.");
          console.log(e);
        });
    },
    pesquisarPorDescricao() {
      let data = {
        campo: "descricao",
        valor: this.descricao,
      };

      this.pesquisarProduto(data);
    },
    focusPrecoUnitario() {
      document.getElementById("preco_unitario").focus().select();
    },
    focusQuantidade() {
      setTimeout(() => {
        document.getElementById("quantidade").focus();
        this.desconto = "";
        this.somaTotalItem();
      }, 100);
    },
    focusDescontoUnitario() {
      document.getElementById("desconto_unitario").focus();
    },
    focusDescontoPercentual() {
      document.getElementById("desconto_percentual").focus();
    },
    focusCodigoDeBarra() {
      document.getElementById("codigo_barra").focus();
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if (keyCode == 113) e.preventDefault();
      if (keyCode == 114) e.preventDefault();

      if (keyCode == 113) {
        this.setModalPesquisarProdutosOrcamento(true);
      }

      if (keyCode == 114) {
        this.setModalPesquisarContato(true);
      }
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.visualizarOrcamento(this.$route.params.id);
    }
  },
  created() {
    this.quantidade = "1,00";
    this.setModalPesquisarProdutosOrcamento(false);
    // this.setModalPesquisarContato(false);
    this.debouncedPesquisarPorCodigoDeBarras = _.debounce(
      this.pesquisarPorCodigoDeBarras,
      300
    );
    this.debouncedPesquisarPorDescricao = _.debounce(
      this.pesquisarPorDescricao,
      300
    );
    this.debouncedBuscarContato = _.debounce(this._buscarContato, 500);

    document.addEventListener("keydown", this.keyUp);
  },
  beforeMount() {
    setTimeout(() => {
      this.setDrawer(false);
    }, 100);
  },
  beforeDestroy() {
    // this.$store.commit('setContato', {})
    this.$store.commit("setProdutoVenda", {});
    this.$store.commit("setProduto", {});
  },
};
</script>
